import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from 'app/features/auth/data-access/auth.service';
import { map, catchError, of } from 'rxjs';

/**
 * Guard que restringe el acceso basado en roles.
 * Bloquea el acceso si el usuario tiene alguno de los roles especificados.
 * 
 * @param blockedRoles - Array de roles que NO pueden acceder a la ruta
 */
export function roleGuard(blockedRoles: string[]): CanActivateFn {
  return (route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);

    // Si no está autenticado, redirigir al login
    if (!auth.isAuthenticated) {
      router.navigate(['/login']);
      return false;
    }

    // Obtener el rol del usuario
    const user = auth.currentUser;
    const userRole = user?.role?.toLowerCase() || '';
    
    // Verificar si el rol del usuario está en la lista de roles bloqueados
    const isBlocked = blockedRoles.some(
      blockedRole => userRole === blockedRole.toLowerCase() || 
                     userRole.includes(blockedRole.toLowerCase())
    );

    if (isBlocked) {
      // Redirigir al inicio si el usuario no tiene acceso
      router.navigate(['/inicio']);
      return false;
    }

    return true;
  };
}

